import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemPreVisitTicketInfoComponent } from '../../components/item-pre-visit-ticket-info/item-pre-visit-ticket-info.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-pre-visit-ticket-info',
	templateUrl: './modal-pre-visit-ticket-info.component.html',
	imports: [ CommonModule, TranslatePipe, ItemPreVisitTicketInfoComponent, FormsModule ]
})
export class ModalPreVisitTicketInfoComponent implements OnInit {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalPreVisitTicketInfoComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.original = this.vm.ticket;
		this.vm.ticket = this.angularHelperService.copy(this.vm.ticket) || {};
		this.vm.close = this.close;
	}
	
	close() {
		this.dialogRef.close();
	}
	
}